<template>
  <div>
    <Avatar
      :image="getIcon(sportIconName)"
      class="mb-3"
      size="normal"
      shape="circle"
      style="background-color: var(--primary-color); color: var(--primary-color-text)"
    />
    <h3 class="font-bold mb-2">{{ title }}</h3>
    <p>{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
import Avatar from 'primevue/avatar'

const icons = import.meta.glob('/src/assets/images/sport/*.svg', {
  eager: true,
  import: 'default',
}) as Record<string, string>

function getIcon(name: string): string | undefined {
  return icons[`/src/assets/images/sport/${name}.svg`]
}

defineProps<{
  sportIconName: string
  title: string
  description: string
}>()
</script>
